__turbopack_context__.v({
  "blocksBackgroundColor": "RightColumnWidget-module-scss-module__glIj4a__blocksBackgroundColor",
  "blocksFontColor": "RightColumnWidget-module-scss-module__glIj4a__blocksFontColor",
  "eventsWidget": "RightColumnWidget-module-scss-module__glIj4a__eventsWidget",
  "header": "RightColumnWidget-module-scss-module__glIj4a__header",
  "secondaryNavBackgroundColor": "RightColumnWidget-module-scss-module__glIj4a__secondaryNavBackgroundColor",
  "themeBackgroundColor": "RightColumnWidget-module-scss-module__glIj4a__themeBackgroundColor",
  "themeFontColor": "RightColumnWidget-module-scss-module__glIj4a__themeFontColor",
  "themeFontFamily": "RightColumnWidget-module-scss-module__glIj4a__themeFontFamily",
  "upcomingNews": "RightColumnWidget-module-scss-module__glIj4a__upcomingNews",
  "widget": "RightColumnWidget-module-scss-module__glIj4a__widget",
});
